(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // === CART DRAWER LOGIC ===
  (function () {
    var cartBtn     = document.getElementById('cart-icon-btn');
    var cartDrawer  = document.getElementById('cart-drawer');
    var cartOverlay = document.getElementById('cart-drawer-overlay');
    var cartClose   = document.getElementById('cart-drawer-close');
    var cartBody    = document.getElementById('cart-drawer-body');

    function openDrawer() {
      cartDrawer.classList.add('is-open');
      cartOverlay.classList.add('is-open');
      cartDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      renderCart();
    }

    function closeDrawer() {
      cartDrawer.classList.remove('is-open');
      cartOverlay.classList.remove('is-open');
      cartDrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function formatMoney(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' Lei';
    }

    function updateBadge(count) {
      var bubble = document.getElementById('cart-count-bubble');
      var number = document.getElementById('cart-count-number');
      var btn    = document.getElementById('cart-icon-btn');

      if (count > 0) {
        if (!bubble && btn) {
          var newBubble = document.createElement('div');
          newBubble.className = 'cart-count-bubble';
          newBubble.id = 'cart-count-bubble';
          newBubble.innerHTML = '<span aria-hidden="true" id="cart-count-number">' + (count > 99 ? '99+' : count) + '</span>';
          btn.appendChild(newBubble);
        } else if (bubble) {
          bubble.style.display = '';
          if (number) number.textContent = count > 99 ? '99+' : count;
        }
      } else {
        if (bubble) bubble.style.display = 'none';
      }
    }

    function renderCart() {
      var footer = document.getElementById('cart-drawer-footer');
      var totalPrice = document.getElementById('cart-drawer-total-price');

      cartBody.innerHTML = '<div class="cart-empty"><p>Se încarcă...</p></div>';
      if (footer) footer.style.display = 'none';

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateBadge(cart.item_count);

          if (cart.item_count === 0) {
            cartBody.innerHTML = [
              '<div class="cart-empty">',
              '<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">',
              '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>',
              '<line x1="3" y1="6" x2="21" y2="6"/>',
              '<path d="M16 10a4 4 0 01-8 0"/>',
              '</svg>',
              '<p>Coșul tău este gol</p>',
              '</div>'
            ].join('');
            if (footer) footer.style.display = 'none';
            return;
          }

          var itemsHTML = cart.items.map(function (item) {
            return [
              '<div class="cart-item" data-key="' + item.key + '">',
              item.image
                ? '<img class="cart-item__img" src="' + item.image + '" alt="' + item.product_title + '" loading="lazy">'
                : '<div class="cart-item__img-placeholder"></div>',
              '<div class="cart-item__info">',
              '<p class="cart-item__title">' + item.product_title + '</p>',
              '<div class="cart-item__bottom">',
              '<div class="cart-item__qty-controls">',
              '<button class="qty-btn qty-minus" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" type="button"' + (item.quantity <= 1 ? ' disabled' : '') + '>−</button>',
              '<span class="qty-value">' + item.quantity + '</span>',
              '<button class="qty-btn qty-plus" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" type="button">+</button>',
              '</div>',
              '<button class="cart-item__remove" data-key="' + item.key + '" type="button">Șterge</button>',
              '</div>',
              '</div>',
              '<div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>',
              '</div>'
            ].join('');
          }).join('');

          cartBody.innerHTML = itemsHTML;

          // Afișează footer-ul static și actualizează totalul
          if (footer) footer.style.display = '';
          if (totalPrice) totalPrice.textContent = formatMoney(cart.total_price);

          cartBody.querySelectorAll('.qty-btn').forEach(function (btn) {
            btn.addEventListener('click', function () {
              var key = this.getAttribute('data-key');
              var qty = parseInt(this.getAttribute('data-qty'), 10);
              updateQuantity(key, qty);
            });
          });

          cartBody.querySelectorAll('.cart-item__remove').forEach(function (btn) {
            btn.addEventListener('click', function () {
              var key = this.getAttribute('data-key');
              updateQuantity(key, 0);
            });
          });
        })
        .catch(function () {
          cartBody.innerHTML = '<div class="cart-empty"><p>Nu am putut încărca coșul.</p></div>';
          if (footer) footer.style.display = 'none';
        });
    }

    function updateQuantity(key, qty) {
      cartBody.querySelectorAll('.qty-btn, .cart-item__remove').forEach(function (b) {
        b.disabled = true;
      });

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function () { renderCart(); })
        .catch(function () { renderCart(); });
    }

    // Badge la load pagină
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateBadge(cart.item_count); });

    // Click pe iconița cart
    if (cartBtn) cartBtn.addEventListener('click', openDrawer);

    // Închidere drawer
    if (cartClose) cartClose.addEventListener('click', closeDrawer);
    if (cartOverlay) cartOverlay.addEventListener('click', closeDrawer);

    // ESC închide drawer
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    // Actualizează badge la cart:updated
    document.addEventListener('cart:updated', function (e) {
      var count = e.detail && e.detail.cart ? e.detail.cart.item_count : null;
      if (count !== null) {
        updateBadge(count);
      } else {
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateBadge(cart.item_count); });
      }
    });

    // Interceptare fetch → deschide drawer la add-to-cart (necesar pentru Selleasy "In cart upsell")
    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = Array.prototype.slice.call(arguments);
      var url = args[0];
      if (typeof url === 'string' && url.includes('/cart/add')) {
        return originalFetch.apply(this, args).then(function (response) {
          if (response.ok) {
            response.clone().json().then(function () { openDrawer(); });
          }
          return response;
        });
      }
      return originalFetch.apply(this, args);
    };

    // Interceptare XMLHttpRequest (scripturi mai vechi)
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._cartUrl = url;
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this._cartUrl && this._cartUrl.includes('/cart/add')) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) openDrawer();
        });
      }
      return origSend.apply(this, arguments);
    };

  })();

  } catch(e) { console.error(e); }
})();
})();
